<template>
    <v-container class="mt-5 d-flex justify-center">
        <v-row class="d-flex justify-center">
            <v-col cols="9">
                <h1>{{ $t("settings.establishments") }}</h1>
            </v-col>
            <v-col cols="3" class="d-flex justify-end py-3">
                <v-btn
                    rounded
                    size="small"
                    elevation="0"
                    @click="newEstablishmentDialog = true"
                    variant="outlined"
                    icon="mdi-plus"
                >
                    {{ $t("shared.add") }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="establishmentsItems.length">
            <v-col
                :cols="isMobile ? 12 : 6"
                class="my-0 pa-2"
                v-for="establishment in establishmentsItems"
                :key="establishment.id"
            >
                <v-card class="default_card ma-0 pa-0" elevation="0" style="margin: 5px">
                    <v-row class="d-flex align-center">
                        <v-col cols="2" v-if="!isMobile">
                            <v-icon color="secondary" size="x-large">mdi-store</v-icon>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 10" class="py-0">
                            <div class="d-flex align-center primary--text justify-space-between">
                                <span
                                    :class="isMobile ? 'ml-2' : ''"
                                    style="font-weight: bold; font-size: 16pt"
                                >
                                    {{ establishment.name }}
                                </span>
                            </div>
                            <div class="d-flex align-center justify-space-between">
                                <span :class="isMobile ? 'ml-2' : ''">
                                    {{ establishment.address }}<br />
                                    {{ establishment.city }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else class="d-flex justify-center">
            <v-col :cols="isMobile ? 12 : 6" class="my-0 pa-2">
                <v-card class="default_card ma-0 pa-0" elevation="0" style="margin: 5px">
                    <v-row class="d-flex align-center">
                        <v-col cols="2" v-if="!isMobile">
                            <v-icon color="secondary" size="x-large">mdi-store</v-icon>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 10" class="py-0">
                            <div class="d-flex align-center primary--text justify-space-between">
                                <span
                                    :class="isMobile ? 'ml-2' : ''"
                                    style="font-weight: bold; font-size: 16pt"
                                >
                                    Aucun &#xc9;tablissement
                                </span>
                            </div>
                            <div class="d-flex align-center justify-space-between">
                                <span :class="isMobile ? 'ml-2' : ''">
                                    Vous n'avez enregistré aucun établissement
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <SirenCompanyDialog
            v-model="newEstablishmentDialog"
            :sire-input="company.siren"
            :siren-mode="true"
            @close="createNewEstablishment"
        />
        <oss-dialog
            v-model="newEstablishmentEditDialog"
            v-if="companyEstablishmentEdit"
            title="Modifier les informations de votre société"
        >
            <EditCompany
                :settings-mode="true"
                :admin-mode="true"
                :in-company="companyEstablishmentEdit"
                @updated="addEstablishment"
            />
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import EditCompany from "../EditCompany.vue";
import SirenCompanyDialog from "../SirenCompanyDialog.vue";

import COMPANY_ESTABLISHMENT_LINK from "../../graphql/company/CompanyEstablishmentLink.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { useDisplay } from "vuetify";
import { computed } from "vue";

@Component({
    components: {
        EditCompany,
        SirenCompanyDialog,
    },
})
export class Establishments extends Vue {
    @Prop({ default: null }) company: any;

    newEstablishmentDialog = false;
    companyEstablishmentEdit: any = null;
    newEstablishmentEditDialog = false;

    establishmentsHeaders: Array<any> = [
        { text: "Nom de l'établissement", value: "name", align: "left", sortable: false },
        { text: "Adresse", value: "address", align: "left", sortable: false },
    ];
    isMobile;
    created() {
        const { xsOnly } = useDisplay();
        this.isMobile = computed(() => xsOnly.value);
    }
    get establishmentsItems() {
        const establishments: Array<any> = [];
        if (this.company.establishments && this.company.establishments.length > 0) {
            this.company.establishments.forEach((x) => {
                establishments.push({
                    name: x.name,
                    address: x.address,
                    city: x.city,
                });
            });
        }
        return establishments;
    }

    get companyId() {
        return this.$route.params.id;
    }

    createNewEstablishment(data: any = undefined) {
        this.newEstablishmentDialog = false;
        console.log(data);
        this.companyEstablishmentEdit = data;
        this.newEstablishmentEditDialog = true;
    }

    async addEstablishment(data: any = undefined) {
        this.newEstablishmentEditDialog = false;
        this.company.establishments.push(data);
        await this.$apollo.mutate({
            mutation: COMPANY_ESTABLISHMENT_LINK,
            variables: {
                idCompany: this.companyId,
                idEstablishment: data.id,
            },
        });
    }
}

export default toNative(Establishments);
</script>
